module.exports = ".icon {\r\n    color:#00900a;\r\n}\r\n\r\n.icon-search {\r\n    color:#000;\r\n}"